import { SwapOutlined } from "@ant-design/icons";
import { Badge, Button } from "antd";
import { useIsMobileView } from "../../hooks/ui-hook";

const TransferToEHRButton = ({ className = "" }: { className?: string } = {}) => {
  const isMobile = useIsMobileView();

  const handleTransferToEHR = () => {
    window.open(
      "https://chromewebstore.google.com/detail/khnjmojbacjmfbplefmcinlmlbifhjnj?utm_source=item-share-cb",
      "_blank",
    );
  };
  if (isMobile) return null;
  return (
    <Button
      type="primary"
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
      }}
      onClick={handleTransferToEHR}
    >
      Transfer to EHR
    </Button>
  );
};

export default TransferToEHRButton;
